import { useState } from 'react';

import { equal } from '@wry/equality';

/**
 * Returns the previous value when the new value is structurally equal,
 * so callers can rely on reference stability for `useMemo` / `useEffect` deps.
 */
export const useDeepStable = <T>(value: T): T => {
  const [stable, setStable] = useState<T>(value);

  if (!equal(stable, value)) {
    // Setting state during render is a supported React pattern; the current value
    // becomes the stable reference carried into future renders.
    setStable(value);
    return value;
  }

  return stable;
};
